import { useState } from 'react';
import { IconUp, IconDown } from '@ui/src';

import { AdditionInfoBlockTypes } from './types';

import cn from '../styles.module.css';

const AdditionalInfoBlock = ({
  title,
  children,
  withoutTitle,
}: AdditionInfoBlockTypes) => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className={cn.additionalInfoBlock}>
      {!withoutTitle && (
        <button
          type="button"
          className={cn.additionalInfoBlockTitle}
          onClick={() => setCollapsed(!collapsed)}
        >
          {title}
          <div className={cn.additionalInfoBlockIcon}>
            {!collapsed ? (
              <IconUp className={cn.iconUp} />
            ) : (
              <IconDown className={cn.iconDown} />
            )}
          </div>
        </button>
      )}

      {!collapsed && (
        <div className={cn.additionalInfoBlockContent}>{children}</div>
      )}
    </div>
  );
};

export default AdditionalInfoBlock;
